import { render, staticRenderFns } from "./notification-dialog.vue?vue&type=template&id=fb3fb390&scoped=true&lang=pug&"
import script from "./notification-dialog.vue?vue&type=script&lang=ts&"
export * from "./notification-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./notification-dialog.vue?vue&type=style&index=0&id=fb3fb390&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3fb390",
  null
  
)

export default component.exports